import styled from "styled-components";
import { colors } from "~/constants/colors";
import { spacing } from "~/constants/spacing";

export const MatchWithYourCompanyContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${spacing.md};

  > a {
    cursor: pointer;
    transition: 0.25s;
    background-color: ${colors.green};
    height: 48px;
    margin-top: ${spacing.sm};
    align-self: end;
    text-transform: uppercase;
    letter-spacing: 5px;
    font-size: 12px;
    display: flex;
    justify-content: center;
    align-items: center;
    align-self: center;
    @media (min-width: 750px) {
      width: 416px;
    }

    @media (max-width: 750px) {
      width: 100%;
    }

    &:hover {
      filter: brightness(1.25);
    }
  }
`;
